import React, { useContext, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import "../servicesOperation.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import useAuth from "hooks/useAuth";
import { AppGlobalContext } from "contexts/GlobalContext";
import { Stack, Typography } from "@mui/material";

//Pasamos la data de la API & el estado del Loading
const Admin_Form_Header = ({
  formData,
  handleChangeSku,
  isLoading,
  onHeaderDataChange,
}) => {
  // Obtenemos la fecha de ahora, y lo colocamos en el formato deseado
  const date_created = formData.date_created;
  //console.log(date_created);

  const { mainCountry } = useContext(AppGlobalContext);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [country, setCountry] = useState(mainCountry);
  const { accessToken } = useAuth();

  const estado_procesado = formData.estado === 3;

  let dateStr = "",
    timeStr = "",
    dateStr_Meli = "";

  if (!isNaN(Date.parse(date_created))) {
    const dateObject = new Date(date_created);
    const dateObject_meli = new Date(formData.devoluciones_fecha_entregado);

    // Convertir a zona horaria Argentina UTC-3
    const argentinaTime = new Date(dateObject.getTime() - 3 * 60 * 60 * 1000); // Restar 3 horas

    dateStr = argentinaTime.toISOString().split("T")[0]; // Formato 'YYYY-MM-DD'
    dateStr_Meli = dateObject_meli.toISOString().split("T")[0]; // Formato 'YYYY-MM-DD'
    timeStr = argentinaTime.toTimeString().split(" ")[0].substring(0, 5); // Formato 'HH:MM'
  } else {
    console.error("Fecha no válida:", date_created);
  }
  //Estados para validación de cada input
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [isEditable, setIsEditable] = useState(
    formData.publicaciones_sku === "",
  );

  console.log("formData");
  console.log(formData);

  // Función para marcar un campo como tocado
  const handleBlur = (id) => {
    //console.log("Log: id handleBlur");
    //console.log(id);
    setTouched((prevState) => ({
      ...prevState,
      [id]: true,
    }));
    validateField(id, formData[id]);
  };

  const validateField = (id, value) => {
    //console.log("VALUE VALIDATE_FIELD");
    //console.log(value);
    // Si el valor es nulo o el string vacío, establecer el error
    if (!value) {
      setErrors((prevState) => ({
        ...prevState,
        [id]: "Este campo es obligatorio",
      }));
    } else {
      // Eliminar el error si el campo es válido
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    }
  };
  useEffect(() => {
    handleBlur("envios_numero_de_seguimiento");
    handleBlur("ventas_num_de_venta");
    handleBlur("publicaciones_sku");
  }, [formData]);
  //Estado para mostrar u ocultar el detalle
  // const [detail, setDetail] = useState(false);

  //Definimos useNavigate para redireccionar al usuario
  const navigate = useNavigate();

  // Hook de autenticación para obtener permisos del usuario
  const { user } = useAuth();

  // Verificar si el usuario tiene permisos de administrador
  const hasAdminPermission =
    user?.permissions?.includes("ServiceOp:viewSAdmin") || false;

  // Función para manejar cambios en los campos del header
  const handleHeaderFieldChange = (fieldName, value) => {
    if (onHeaderDataChange) {
      onHeaderDataChange(fieldName, value);
    }
  };

  //Redirecciona al usuario en caso de clickear botón
  const handleBackRoute = (event) => {
    event.preventDefault();
    navigate("/service-operation/admin");
  };

  const autocompleteFormShipping = async (seguimiento = null) => {
    try {
      const payload = {
        nroventa: "",
        fecha: "",
        sku: "",
        seguimiento: seguimiento,
        pais: country.id.toString(),
      };

      const request = await fetch(
        `${baseUrl}/ServiceOperation/ProductFormAutoComplete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const response = await request.json();
      handleHeaderFieldChange(
        "publicaciones_sku",
        response?.sku || formData.publicaciones_sku,
      );
      handleHeaderFieldChange(
        "ventas_num_de_venta",
        response?.orderId || formData.ventas_num_de_venta,
      );
      handleHeaderFieldChange(
        "envios_numero_de_seguimiento",
        response?.shipId || formData.envios_numero_de_seguimiento,
      );
    } catch (error) {}
  };

  const autocompleteFormOrder = async (nroventa = null) => {
    try {
      const payload = {
        nroventa: nroventa,
        fecha: "",
        sku: "",
        seguimiento: "",
        pais: country.id.toString(),
      };

      const request = await fetch(
        `${baseUrl}/ServiceOperation/ProductFormAutoComplete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const response = await request.json();
      handleHeaderFieldChange(
        "publicaciones_sku",
        response?.sku || formData.publicaciones_sku,
      );
      handleHeaderFieldChange(
        "ventas_num_de_venta",
        response?.orderId || formData.ventas_num_de_venta,
      );
      handleHeaderFieldChange(
        "envios_numero_de_seguimiento",
        response?.shipId || formData.envios_numero_de_seguimiento,
      );
    } catch (error) {}
  };

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <>
          <Box
            sx={{
              flexGrow: 1,
              border: "1px solid #0000003B",
              borderRadius: "4px",
              padding: "16px",
              gap: "16px",
              flexDirection: "column",
              display: "flex",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "semi-bold",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "0.15px",
                  color: "#424242",
                }}
              >
                📦 DATOS DEL PRODUCTO
              </Typography>
            </Stack>

            {/* //Admin Normal */}
            {!hasAdminPermission && (
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="1"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <TextField
                  sx={{ width: "100%" }}
                  id="outlined-numero_envio"
                  label="Número de envío"
                  value={formData.envios_numero_de_seguimiento || ""}
                  onChange={(e) =>
                    hasAdminPermission &&
                    autocompleteFormShipping(e.target.value) &&
                    handleHeaderFieldChange(
                      "envios_numero_de_seguimiento",
                      e.target.value,
                    )
                  }
                  disabled={!hasAdminPermission || !(formData.estado < 4)}
                  onBlur={() => handleBlur("envios_numero_de_seguimiento")}
                  error={Boolean(
                    touched?.["envios_numero_de_seguimiento"] &&
                    errors?.["envios_numero_de_seguimiento"],
                  )}
                /> */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    N° Seguimiento
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {formData.envios_numero_de_seguimiento}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="2"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <TextField
                  sx={{ width: "100%" }}
                  id="outlined-numero_venta"
                  label="Número de Venta"
                  value={formData.ventas_num_de_venta || ""}
                  onChange={(e) =>
                    hasAdminPermission &&
                    autocompleteFormOrder(e.target.value) &&
                    handleHeaderFieldChange(
                      "ventas_num_de_venta",
                      e.target.value,
                    )
                  }
                  disabled={!hasAdminPermission || !(formData.estado < 4)}
                  onBlur={() => handleBlur("ventas_num_de_venta")}
                  error={Boolean(
                    touched?.["ventas_num_de_venta"] &&
                    errors?.["ventas_num_de_venta"],
                  )}
                /> */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    N° Venta
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {formData.ventas_num_de_venta}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="3"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <TextField
                  sx={{ width: "100%" }}
                  id="outlined-sku"
                  label="SKU"
                  onChange={(e) => {
                    handleChangeSku(e.target.value);
                    handleBlur("publicaciones_sku");
                    // También actualizar a través del callback del header
                    hasAdminPermission &&
                      handleHeaderFieldChange(
                        "publicaciones_sku",
                        e.target.value,
                      );
                  }}
                  value={formData.publicaciones_sku}
                  disabled={!hasAdminPermission || !(formData.estado < 4)}
                  error={Boolean(
                    touched?.["publicaciones_sku"] &&
                    errors?.["publicaciones_sku"],
                  )}
                  onBlur={() => handleBlur("publicaciones_sku")}
                  required={true}
                />
              
                {/* ESTOS VALORES SON LOS TIMESTAMP */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    SKU
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {formData.publicaciones_sku}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="4"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <TextField
                  sx={{ width: "100%" }}
                  id="outlined-hora_ingreso"
                  label="Fecha Devolucion"
                  value={dateStr_Meli}
                  disabled
                /> */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    Fecha Devolucion
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {dateStr_Meli}
                  </Typography>
                  {/* ESTOS VALORES SON LOS TIMESTAMP */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="5"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <TextField
                  sx={{ width: "100%" }}
                  id="outlined-fecha_ingreso"
                  label="Fecha de Ingreso"
                  value={`${dateStr} ${timeStr}`}
                  disabled
                />{" "} */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    Fecha de Ingreso
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {`${dateStr} ${timeStr}`}
                  </Typography>
                </Grid>
                {/*Origen de devolucion solo para procesados y finalizados*/}
                {(formData.estado === 3 || formData.estado === 4) && (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      key="6"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "semi-bold",
                          fontSize: "14px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#00000061",
                        }}
                      >
                        Origen de devolucion
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "normal",
                          fontSize: "16px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#000000DE",
                        }}
                      >
                        {formData.origen_devolucion_name}
                      </Typography>
                    </Grid>
                    {/* //Destino de devolucion solo para procesados */}
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      key="7"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "semi-bold",
                          fontSize: "14px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#00000061",
                        }}
                      >
                        Destino de devolucion
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "normal",
                          fontSize: "16px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#000000DE",
                        }}
                      >
                        {formData.deposito_destino_name}
                      </Typography>
                    </Grid>
                    {/* //Sintoma solo para procesados */}
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      key="8"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "semi-bold",
                          fontSize: "14px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#00000061",
                        }}
                      >
                        Sintoma
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "normal",
                          fontSize: "16px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#000000DE",
                        }}
                      >
                        {formData.sintoma_name}
                      </Typography>
                    </Grid>
                    {/* //Fecha analisis */}
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      key="9"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "semi-bold",
                          fontSize: "14px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#00000061",
                        }}
                      >
                        Fecha analisis
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "normal",
                          fontSize: "16px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#000000DE",
                        }}
                      >
                        {formData.fecha_analisis_taller}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            )}

            {/* //Super Admin */}
            {hasAdminPermission && (
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="1"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <TextField
                    sx={{ width: "100%" }}
                    id="outlined-numero_envio"
                    label="Número de envío"
                    value={formData.envios_numero_de_seguimiento || ""}
                    onChange={(e) =>
                      hasAdminPermission &&
                      autocompleteFormShipping(e.target.value) &&
                      handleHeaderFieldChange(
                        "envios_numero_de_seguimiento",
                        e.target.value,
                      )
                    }
                    disabled={!hasAdminPermission || !(formData.estado < 4)}
                    onBlur={() => handleBlur("envios_numero_de_seguimiento")}
                    error={Boolean(
                      touched?.["envios_numero_de_seguimiento"] &&
                      errors?.["envios_numero_de_seguimiento"],
                    )}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="2"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <TextField
                    sx={{ width: "100%" }}
                    id="outlined-numero_venta"
                    label="Número de Venta"
                    value={formData.ventas_num_de_venta || ""}
                    onChange={(e) =>
                      hasAdminPermission &&
                      autocompleteFormOrder(e.target.value) &&
                      handleHeaderFieldChange(
                        "ventas_num_de_venta",
                        e.target.value,
                      )
                    }
                    disabled={!hasAdminPermission || !(formData.estado < 4)}
                    onBlur={() => handleBlur("ventas_num_de_venta")}
                    error={Boolean(
                      touched?.["ventas_num_de_venta"] &&
                      errors?.["ventas_num_de_venta"],
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="3"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <TextField
                    sx={{ width: "100%" }}
                    id="outlined-sku"
                    label="SKU"
                    onChange={(e) => {
                      handleChangeSku(e.target.value);
                      handleBlur("publicaciones_sku");
                      // También actualizar a través del callback del header
                      hasAdminPermission &&
                        handleHeaderFieldChange(
                          "publicaciones_sku",
                          e.target.value,
                        );
                    }}
                    value={formData.publicaciones_sku}
                    disabled={!hasAdminPermission || !(formData.estado < 4)}
                    error={Boolean(
                      touched?.["publicaciones_sku"] &&
                      errors?.["publicaciones_sku"],
                    )}
                    onBlur={() => handleBlur("publicaciones_sku")}
                    required={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="4"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    Fecha Devolucion
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {dateStr_Meli}
                  </Typography>
                  {/* ESTOS VALORES SON LOS TIMESTAMP */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key="5"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "semi-bold",
                      fontSize: "14px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#00000061",
                    }}
                  >
                    Fecha de Ingreso
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "normal",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      color: "#000000DE",
                    }}
                  >
                    {`${dateStr} ${timeStr}`}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>
        </>
      )}
    </>
  );
};
export default Admin_Form_Header;
